import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
  standalone: false,
})
export class TimeAgoPipe implements PipeTransform {
  constructor() {}

  public transform(value: string | Date): string | null {
    const now = new Date();
    const date = new Date(value);
    const seconds = Math.round(Math.abs((now.getTime() - date.getTime()) / 1000));
    const minutes = Math.round(Math.abs(seconds / 60));
    const hours = Math.round(Math.abs(minutes / 60));
    const days = Math.round(Math.abs(hours / 24));

    if (Number.isNaN(seconds)) {
      return '';
    } else if (minutes < 5) {
      return 'just now';
    }
    if (minutes <= 59) {
      return minutes + 'm ago';
    }
    if (hours <= 23) {
      return hours + 'h ago';
    } else if (days <= 6) {
      return days + 'd ago';
    } else {
      return new DatePipe('en').transform(date, 'd MMM yyyy');
    }
  }
}
